import { FC, useCallback } from 'react';
import { useFormikContext } from 'formik';

import AddIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import InputAdornment from '@mui/material/InputAdornment';

import ConfirmableIconButton from 'components/ConfirmableIconButton';
import DatePicker from 'components/DatePicker';
import PaymentTypeSelect from 'components/PaymentTypeSelect';
import TextField from 'components/TextField';
import PaymentStatusText from 'components/PaymentStatusText';
import { useCurrentUser } from 'components/CurrentUserProvider';

type Props = {
  onCancel: () => void;
};

const OrderEditMainPaymentsAdd: FC<Props> = ({ onCancel }) => {
  const { dirty, resetForm, submitForm } = useFormikContext();
  const { name } = useCurrentUser();

  const handleAdd = useCallback(() => {
    submitForm();
  }, [submitForm]);

  const handleCancel = useCallback(() => {
    resetForm();
    onCancel();
  }, [onCancel, resetForm]);

  return (
    <TableRow>
      <TableCell sx={{ verticalAlign: 'top' }}>
        <Box sx={{ maxWidth: '120px', minWidth: '120px' }}>
          <DatePicker name="paymentDate" />
        </Box>
      </TableCell>

      <TableCell sx={{ verticalAlign: 'top' }}>
        <PaymentTypeSelect name="type" placeholder="Tipas" />
      </TableCell>

      <TableCell sx={{ verticalAlign: 'top' }}>
        <TextField name="details" placeholder="Komentaras" />
      </TableCell>

      <TableCell sx={{ verticalAlign: 'top' }}>
        <PaymentStatusText status="PAID" />
      </TableCell>

      <TableCell sx={{ verticalAlign: 'top' }}>
        <Box sx={{ maxWidth: '75px', minWidth: '75px' }}>
          <TextField
            name="amount"
            placeholder="Suma"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">€ </InputAdornment>
              ),
            }}
          />
        </Box>
      </TableCell>

      <TableCell>{name}</TableCell>

      <TableCell sx={{ verticalAlign: 'top' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Tooltip title="Pridėti">
            <IconButton size="small" onClick={handleAdd}>
              <AddIcon fontSize="small" color="success" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Atšaukti">
            <ConfirmableIconButton enabled={dirty} onConfirm={handleCancel}>
              <CancelIcon fontSize="small" />
            </ConfirmableIconButton>
          </Tooltip>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default OrderEditMainPaymentsAdd;
